const initialState = {
  purchaseRequests: [],
  purchaseRequestsLoaded: false,
  loading: false,
};

const prKey = (pr) => String(pr?.POID ?? pr?.id ?? "");

const hasPrLines = (pr) =>
  Array.isArray(pr?.lineItems) && pr.lineItems.length > 0;

/** Prefer richer lineItems so list/Sync replace don't wipe hole-filled detail. */
const mergePurchaseRequestPreserveLines = (existing, incoming) => {
  if (!incoming) return existing || null;
  if (!existing) return incoming;
  const keepLines =
    !hasPrLines(incoming) && hasPrLines(existing)
      ? existing.lineItems
      : incoming.lineItems;
  const keepFetched = Boolean(existing.__detailFetched || incoming.__detailFetched);
  return {
    ...existing,
    ...incoming,
    lineItems: keepLines ?? existing.lineItems ?? incoming.lineItems ?? [],
    ...(keepFetched ? { __detailFetched: true } : {}),
  };
};

const purchaseRequestsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PURCHASE_REQUESTS": {
      const incoming = Array.isArray(action.payload) ? action.payload : [];
      const prevById = new Map(
        (state.purchaseRequests || []).map((pr) => [prKey(pr), pr])
      );
      const purchaseRequests = incoming.map((pr) => {
        const id = prKey(pr);
        if (!id || id === "null") return pr;
        return mergePurchaseRequestPreserveLines(prevById.get(id), pr);
      });
      return {
        ...state,
        purchaseRequests,
        purchaseRequestsLoaded: true,
        loading: false,
      };
    }

    case "UPSERT_PURCHASE_REQUEST": {
      const incoming = action.payload;
      if (!incoming) return state;
      const id = prKey(incoming);
      if (!id || id === "null") return state;
      const existing = (state.purchaseRequests || []).find(
        (pr) => prKey(pr) === id
      );
      const merged = mergePurchaseRequestPreserveLines(existing, incoming);
      const purchaseRequests = existing
        ? (state.purchaseRequests || []).map((pr) =>
            prKey(pr) === id ? merged : pr
          )
        : [merged, ...(state.purchaseRequests || [])];
      return {
        ...state,
        purchaseRequests,
        purchaseRequestsLoaded: true,
        loading: false,
      };
    }

    default:
      return state;
  }
};

export default purchaseRequestsReducer;
export { mergePurchaseRequestPreserveLines, hasPrLines };
